import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
const AttributeTableRows = ({
  selectCredit,
  rowsData,
  deleteTableRows,
  handleChange,
  callback,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  // const [rowsDataBind, setRowsDataBind] = useState([]);
  // const [selectCreditNew, setselectCredit] = useState([]);

  // const handlevaluechange = (event) => {
  //   console.log(event.target.value);
  // };

  const handleDeleteClick = (index) => {
    console.log("handleDeleteClick==> ", index);

    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    console.log("handleConfirmDelete ==> ", deleteIndex);
    deleteTableRows(deleteIndex);
    setShowDeleteModal(false);

    // const updatedRowsData = rowsData.filter(
    //   (row, index) => index !== deleteIndex
    // );
    // console.log("updatedRowsData =>", updatedRowsData);
    // console.log("selectCredit =>", selectCredit);

    // setRowsDataBind(updatedRowsData);
    // rowsData = updatedRowsData;
    // console.log("updatedRowsData rowsDataBind=>", rowsData);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  // const [tableData, setTableData] = useState([]);
  useEffect(() => {
    callback(rowsData);
    // setRowsDataBind(rowsData);
  }, [rowsData]);

  if (
    selectCredit == 1 ||
    selectCredit == 4 ||
    selectCredit == 9 ||
    selectCredit == 10
  ) {
    // rowsData return

    return rowsData.map((data, index) => {
      const { ID, RegisterName, EmvTerminalId, EnableTips } = data;

      // <AttributeTableRows onClick={onClick} />;
      return (
        <tr key={index}>
          <td>
            <input type="hidden" name="ID" value={ID} />
            <input
              type="text"
              className="form-control"
              name="RegisterName"
              defaultValue={RegisterName}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control"
              name="TerminalID"
              defaultValue={EmvTerminalId}
              onChange={(evnt) => handleChange(index, evnt)}
              // onChange={(event)=>{
              //   handlevaluechange(event)}}
            />
          </td>
          <td>
            <input
              type="checkbox"
              style={{ width: "1.25em", height: "1.25em" }}
              className="form-check-input"
              name="EnableTips"
              defaultValue={EnableTips}
              onChange={(evnt) => {
                handleChange(index, evnt);
              }}
            />
          </td>

          <td>
            <i
              className="fa fa-trash text-red fa-2x"
              data-bs-toggle="tooltip"
              title="Delete"
              onClick={() => handleDeleteClick(index)}
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            />

            {/* Delete confirmation modal */}
            <div
              className={`modal ${showDeleteModal ? "d-block" : ""}`}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirmation</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <h6>Are you sure you want to delete this row?</h6>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancelDelete}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  } else if (
    selectCredit == 2 ||
    selectCredit == 5 ||
    selectCredit == 6 ||
    selectCredit == 7 ||
    selectCredit == 8 ||
    selectCredit == 11
  ) {
    // worldPay return
    return rowsData.map((data, index) => {
      const {
        ID,
        RegisterName,
        EmvTerminalId,
        EnableTips,
        IptranDeviceId,
        EmvPinpadIp,
        EmvPinpadPort,
      } = data;

      return (
        <tr key={index}>
          <td>
            <input type="hidden" name="ID" value={ID} />
            <input
              type="text"
              className="form-control"
              name="RegisterName"
              defaultValue={RegisterName}
              onChange={(evnt) => handleChange(index, evnt)}
              // onChange={(event)=>{
              //      handlevaluechange(event)}}
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control"
              name="TerminalID"
              value={EmvTerminalId}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="checkbox"
              style={{ width: "1.25em", height: "1.25em" }}
              className="form-check-input"
              name="EnableTips"
              value={EnableTips}
              onChange={(evnt) => {
                handleChange(index, evnt);
              }}
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control"
              name="IPTranDeviceID"
              value={IptranDeviceId}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control"
              name="PinPadIP"
              value={EmvPinpadIp}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="number"
              className="form-control"
              name="PinPadPort"
              value={EmvPinpadPort}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <Link className="me-1" to={`https://mailchimp.com`} target="_blank">
              Update Params /
            </Link>
            <Link to={`https://mailchimp.com`} target="_blank">
              Initialize credit card reader
            </Link>
          </td>

          <td>
            <i
              className="fa fa-trash text-red fa-2x"
              data-bs-toggle="tooltip"
              title="Delete"
              onClick={() => handleDeleteClick(index)}
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            />

            {/* Delete confirmation modal */}
            <div
              className={`modal ${showDeleteModal ? "d-block" : ""}`}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirmation</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <h6>Are you sure you want to delete this row?</h6>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancelDelete}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  } else {
    // card connect return
    return rowsData.map((data, index) => {
      const { ID, RegisterName, CardConnectHSN, EnableTips } = data;

      return (
        <tr key={index}>
          <td>
            <input type="hidden" name="ID" value={ID} />
            <input
              type="text"
              className="form-control"
              name="RegisterName"
              value={RegisterName}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="text"
              className="form-control"
              name="CardConnectHSN"
              value={CardConnectHSN}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <input
              type="checkbox"
              style={{ width: "1.25em", height: "1.25em" }}
              className="form-check-input"
              name="EnableTips"
              value={EnableTips}
              onChange={(evnt) => {
                handleChange(index, evnt);
              }}
            />
          </td>

          <td>
            <i
              className="fa fa-trash text-red fa-2x"
              data-bs-toggle="tooltip"
              title="Delete"
              onClick={() => handleDeleteClick(index)}
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            />

            {/* Delete confirmation modal */}
            <div
              className={`modal ${showDeleteModal ? "d-block" : ""}`}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirmation</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <h6>Are you sure you want to delete this row?</h6>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancelDelete}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }
};

export default AttributeTableRows;
